import { IntlShape } from 'react-intl';
import { StockItem } from '../../entity';

export type ShoppingListItemType = {
  id: string;
  item: string;
  price: number;
  amount: number;
  unitAmount: number;
  unit: string;
};

export const createShoppingList = (
  stockItems: StockItem[],
  intl: IntlShape,
): ShoppingListItemType[] => {
  return stockItems.flatMap((item): ShoppingListItemType[] => {
    const threshold = Number(item.threshold);
    const avgPrice = Number(item.avgUnitPrice);
    const lastPackageQuantity = Number(item.lastPackageQuantity);
    const packageCount = Number(item.packageCount);

    if (!item.id) {
      throw new Error(
        `${intl.formatMessage({ id: 'shoppingList.errorItemId', defaultMessage: 'Položka {item_name} nemá ID.' }, { item_name: item.itemName })}`,
      );
    }

    if (packageCount < threshold) {
      const missingPackages = Math.round((threshold - packageCount) * 100) / 100;
      const missingUnits = Math.round(missingPackages * lastPackageQuantity * 100) / 100;

      return [
        {
          id: item.id,
          item: item.itemName,
          price: Math.round(missingUnits * avgPrice * 100) / 100,
          amount: missingPackages,
          unitAmount: missingUnits,
          unit: item.unit,
        },
      ];
    }
    return [];
  });
};
